<template>
  <div class="container flex" v-title data-title="邀请学生">
    <div class="white-container flex column cross-center">
      <div class="user-portrait-container flex main-center cross-center">
        <van-image
          class="user-portrait"
          round
          width="60px"
          height="60px"
          :src="user.avatar"
          @error="onImageError"
        />
      </div>
      <span class="user-name">{{ user.username }}同学</span>

      <div class="input-container">
        <div style="margin-top: 22px" class="flex main-center">
          <div class="flex column main-center input">
            <input type="tel" placeholder="请输入手机号" v-model="mobile" />
          </div>
        </div>
        <div style="margin-top: 10px" class="flex main-center">
          <div class="flex cross-center input">
            <input
              type="tel"
              placeholder="请输入验证码"
              v-model="code"
              style="width: 50px"
            />
            <div style="width: 1px; height: 14px; background: #c2c2c2ff"></div>
            <div
              class="verfityCode"
              :style="{ color: codeTextColor }"
              @click="onSendCodeEvent"
            >
              {{ codeText }}
            </div>
          </div>
        </div>
      </div>

      <div class="register-button ripple flex main-center cross-center" @click="onRegisterEvent">
        <span>立即注册</span>
      </div>

      <img style="margin-left: 10%; margin-top: 20px; width: 239px; height: 47px;" src="../../../assets/invitation/yueban-logo.png"/>
    </div>

    <div class="bottom-bg">
      <img src="../../../assets/invitation/Invitation-bottom-bg.png" />
    </div>

    <van-popup v-model="show" :close-on-click-overlay="overlay" style="background-color: rgba(0, 0, 0, 0.0);">
      <invitation-success-alert detailTitle='立即下载阅伴App，开启阅读闯关挑战之旅。' @onClose='onCloseAlert' @onDownloadApp='onDownloadApp'/>
    </van-popup>
  </div>
</template>

<script>
import * as InvitationsApi from "../../../api/Invitation.js";

export default {
  data() {
    return {
      user: {
        avatar: require('../../../assets/defult_portrait.png')
      },
      mobile: "", //手机号
      code: "", //验证码
      isCanClickCode: true, //是否能点击验证码按钮
      codeText: "发送验证码", //验证码文字
      codeTextColor: "#21BEA1FF", //验证码文字颜色
      timer: null,  //定时器
      count: 60, //倒计时
      show: false, //是否显示弹窗
      overlay: false, //禁止点击蒙版
    };
  },
  // 子组件
  components: {
    'invitation-success-alert': () => import('../../../components/InvitationSuccessAlert.vue')
  },
  created() {
    this.doReqeustStudentInfo();
  },
  mounted() {
    // 清楚定时器
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },

  methods: {
    /**跳转下载app */
    onDownloadApp() {
      this.$router.push({name: 'DownloadStudent'});
    },

    /**关闭弹窗 */
    onCloseAlert() {
      this.show = false
    },

    onImageError () {
      this.user.avatar = require('../../../assets/defult_portrait.png');
    },

    /**
     * 查询学生信息
     */
    async doReqeustStudentInfo() {
      const res = await InvitationsApi.doReqeustStudentInfo();
      if (!res.avatar) res.avatar = require('../../../assets/defult_portrait.png')
      this.user = res;
    },

    /**
     * 发送验证码
     */
    async onSendCodeEvent() {

      if (!this.isCanClickCode) {
        return
      };

      if (this.mobile.length === 0 || this.mobile.length !== 11) {
        this.$notify('请输入正确的手机号码')
        return
      }
      // 请求验证码
      await InvitationsApi.doRequestStudentSendVerificationCode(this.mobile);
      
      // 开始倒计时
      this.timer = setInterval(() => {
        if (this.count > 0 && this.count <= 60) {
            this.isCanClickCode = false;
            this.codeTextColor = "#b8b8b8ff";
            this.count--;
            this.codeText = `重新获取${this.count}s`;
        } else {
            this.codeText = '发送验证码';
            this.isCanClickCode = true;
            this.count = 60;
            this.codeTextColor = "#21BEA1FF";
            clearInterval(this.timer);
            this.timer = null;
        }
      }, 1000);
    },

    /**
     * 注册
     */
    async onRegisterEvent() {
      if (this.mobile.length === 0 || this.mobile.length !== 11) {
        this.$notify("请输入正确的手机号码");
        return;
      }
      if (this.code.length === 0) {
        this.$notify("请输入验证码");
        return;
      }
      await InvitationsApi.doReqeustStudentInvitationStudent(
        this.mobile,
        this.code,
        this.user.userId
      );
      this.show = true
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  height: 100vh;
  width: 100vw;
  min-height: 765px;
  position: relative;
  background-image: url(../../../assets/invitation/bg.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;

  .bottom-bg {
    position: absolute;
    left: 0px;
    right: 0px;
    bottom: 0px;
    height: 170px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}

.white-container {
  position: relative;
  background-image: url(../../../assets/invitation/white-student-1.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: auto 100%;
  margin-left: 30px;
  margin-top: 60px;
  width: 82%; 
  min-width: 308px; 
  height: 70%; 
  min-height: 560px;

  .user-portrait-container {
    background: white;
    width: 70px;
    height: 70px;
    border-radius: 35px;
    margin-top: -10%;
    margin-left: 10px;
  }

  .user-name {
    height: 18px;
    font-size: 13px;
    font-weight: lighter;
    color: #333333;
    text-align: center;
    margin-left: 10px;
  }

  .welcome-text {
    margin-left: 10%;
    width: 80%;
    box-shadow: inset 0px -1px 0px 0px #eeeeee;
  }

  .input-container {
    margin-left: 10%;
    margin-top: 55%;
    width: 80%;

    .input {
      width: 100%;
      height: 40px;
      background: #f6f6f6ff;
      border-radius: 20px;
    }
    .input input {
      min-width: 80px;
      font-size: calc(14 / 375 * 100vw);
      margin-left: 20px;
      // background-color: #f6f6f6ff;
      background-color: rgba(0, 0, 0, 0);
      border: none;
      outline: medium;
      color: #b8b8b8ff;
      flex: 1;
    }

    .input input::-webkit-input-placeholder {
      /* WebKit browsers */
      color: #b8b8b8ff;
    }

    .input input:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #b8b8b8ff;
    }

    .input input::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #b8b8b8ff;
    }

    .input input:-ms-input-placeholder {
      /* Internet Explorer 10+ */
      color: #b8b8b8ff;
    }

    .verfityCode {
      min-width: 100px;
      width: 100px;
      height: 20px;
      font-size: calc(14 / 375 * 100vw);
      // color: rgba(33, 190, 161, 1);
      line-height: 20px;
      flex-shrink: 0;
      margin-left: 5px;
      margin-right: 5px;
      text-align: center;
    }
  }

  .register-button {
    margin-left: 10%;
    margin-top: 35px;
    width: 163px;
    height: 40px;
    background: linear-gradient(90deg, #44b499 0%, #3ee0a2 100%);
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    span {
      height: 18px;
      font-size: 15px;
      font-weight: normal;
      color: #ffffff;
      line-height: 18px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/invitation/student/InvitationStudent.vue